export const InitialFlashValue = false
export const FlashResponseDelay = 5000
